import { useState, useRef, useEffect } from "react";

export default function ServiceDetailPerform() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-perform">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Performance</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-head">
                        <h4 className="heading">Crafted to Endure, Designed to Impress</h4>
                        <p>Each bespoke piece blends luxury with functionality, ensuring it performs daily while retaining elegance.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-list">
                        <p>Find out more</p>
                        <ul>
                            <li><span>01</span> Designed for longevity with premium cores and robust joinery.</li>
                            <li><span>02</span> Wide choice of sizes, finishes and upholstery to match interiors.</li>
                            <li><span>03</span> Slim profiles with structural stability for a refined silhouette.</li>
                            <li><span>04</span> Easy-maintenance surfaces and resilient fabrics for everyday living.</li>
                            <li><span>05</span> Coordinated lines to integrate furniture with millwork and modular systems.</li>
                            <li><span>06</span> Custom options for scale, function and storage integration.</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
